<template>
  <a-modal
    :title="title"
    :width="600"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="Close"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="Status">
          <a-select v-decorator="['status']" >
            <a-select-option :key='"00"'>
              Pending
            </a-select-option>
            <a-select-option :key='"01"'>
              No Action Needed
            </a-select-option>
            <a-select-option :key='"02"'>
              Pending Refund
            </a-select-option>
            <a-select-option :key='"03"'>
              Refunding
            </a-select-option>
            <a-select-option :key='"04"'>
              Pending Reduction
            </a-select-option>
            <a-select-option :key='"05"'>
              Processed
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="Remark">
          <a-textarea :maxlength="100" :auto-size="{ minRows: 3, maxRows: 6 }" v-decorator="[ 'remarks']" />
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash/pick'
import Dict from '@/views/webpublic/modules/Dict'
import { repeatRepayFlowUpdate } from '@/webpublicapi/CollectionAccountInfo'
// duplicateCheck
export default {
  name: 'repeatRepayUpdateModule',
  components: {
    Dict,
  },
  data() {
    return {
      title: 'Action',
      visibleCheck: true,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      form: this.$form.createForm(this)
    }
  },
  created() {},
  methods: {
    edit(record) {
      this.form.resetFields()
      this.model = Object.assign({}, record)

      this.visible = true
      const data = pick(this.model, 'status', 'remarks')
      this.$nextTick(() => {
        this.form.setFieldsValue(data)
      })
    },
    onChose(checked) {
      if (checked) {
        this.visibleCheck = true
      } else {
        this.visibleCheck = false
      }
    },
    // Confirm
    handleOk() {
      const that = this
      // Trigger form validation
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          const formData = Object.assign(this.model, values)
          let obj = repeatRepayFlowUpdate(formData)
          obj.then((res) => {
              if (res.code === 1000) {
                that.$message.success(res.msg)
                that.$emit('ok')
              } else {
                that.$message.warning(res.msg)
              }
            })
            .finally(() => {
              that.confirmLoading = false
              that.close()
            })
        }
      })
    },
    // Close
    handleCancel() {
      this.close()
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
  },
}
</script>
